import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {UserService} from '../services/user.service';
import {jwtDecode} from 'jwt-decode';
import {DataService} from "../services/data.service";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {

  constructor(
    private userService: UserService,
    private router: Router,
    private dataService: DataService
  ) {
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    if (!!this.userService.user && !!this.userService.user.id_token) {
      if (AuthenticationGuard.isTokenExpired(this.userService.user.id_token)) {
        try {
          const user = this.userService.user;
          const refresh = await this.dataService.refreshToken(this.userService.user.id_refresh_token) as {
            id_token: string,
            id_refresh_token: string
          };
          user.id_token = refresh.id_token;
          user.id_refresh_token = refresh.id_refresh_token;
          this.userService.setUser(user);
        } catch (e) {
          this.userService.setUser(null);
          this.router.navigate(['/login']);
          return false;
        }
      }

      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }

  public static isTokenExpired(token: string, offsetSeconds?: number): boolean {
    if (token === null || token === '') {
      return true;
    }
    const date = AuthenticationGuard.getTokenExpirationDate(token);
    offsetSeconds = offsetSeconds || 0;

    if (date === null) {
      return true;
    }

    return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
  }

  public static getTokenExpirationDate(token: string): Date | null {
    const decoded = AuthenticationGuard.decodeToken<Partial<{ exp: number }>>(token);

    if (!decoded.hasOwnProperty('exp')) {
      return null;
    }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);

    return date;
  }

  public static decodeToken<T>(token: string): T {
    return jwtDecode<T>(token);
  }
}
